module.exports = __webpack_public_path__ + "static/media/South Africa.bc02ac45.png";